import { render, staticRenderFns } from "./MaterialComponent.vue?vue&type=template&id=f86c9f9e&"
import script from "./MaterialComponent.vue?vue&type=script&lang=js&"
export * from "./MaterialComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports